/**
 * Two uploader
 */
class TwoUploader {
    wrapElem;
    inputFileSelector1;
    inputFileSelector2;
    wrapBoxSelector;
    switchSelector;
    selectors;
    files = {};

    /**
     * Constructor
     * @param {HTMLElement} wrapElem
     * @param {String} inputFileSelector1
     * @param {String} inputFileSelector2
     * @param {String} wrapBoxSelector
     * @param {String} switchSelector
     * @param {String} moreSelector
     */
    constructor({
        wrapElem,
        inputFileSelector1 = 'data-two-uploader-file-1',
        inputFileSelector2 = 'input[data-two-uploader-file-2]',
        wrapBoxSelector = '[data-two-uploader-box]',
        switchSelector = '[data-two-uploader-check]',
        moreSelector = '[data-two-uploader-more]',
    }) {
        this.wrapElem = wrapElem;
        this.inputFileSelectorAttr1 = inputFileSelector1;
        this.inputFileSelector1 = `input[${inputFileSelector1}]`;
        this.inputFileSelector2 = inputFileSelector2;
        this.wrapBoxSelector = wrapBoxSelector;
        this.switchSelector = switchSelector;
        this.moreSelector = moreSelector;
        this.selectors = {
            elemBar: 'progress-bar',
            elemBarItem: 'progress-bar__item',
            wrapElemName: 'service_repair-form_file-name-wrap',
            countItem: 'count-item',
            removeBtn: 'close-icon',
        };

        this.render();
    }

    /**
     * Builder run
     * @param {Object} data
     * @returns {TwoUploader}
     */
    static run(data = {}) {
        return new TwoUploader(data);
    }

    /**
     * Show progress load
     * @param {String} name
     * @param {HTMLElement} box
     * @param {HTMLElement} target
     */
    static showProgressBar(name, box, target) {
        let width = 1;
        let id = setInterval(() => {
            if (width >= 100) {
                clearInterval(id);
                box.innerHTML = name;
            } else {
                width++;
                target.style.width = `${width}%`;
            }
        }, 10);
    }

    /**
     * Get next num
     * @param {Object} files
     * @returns {number}
     */
    static getNextIndex(files) {
        if (Object.keys(files).length === 0) {
            return 0;
        }

        let max = 0;

        for (let key in files) {
            if (Object.prototype.hasOwnProperty.call(files, key) && parseInt(key, 10) > max) {
                max = parseInt(key, 10);
            }
        }

        return max + 1;
    }

    /**
     * Action on change input
     * @param {InputEvent} e
     */
    startAction = (e) => {
        const nextIndex = TwoUploader.getNextIndex(this.files);
        const targetElem = e.target;

        const isWarranty = targetElem.hasAttribute(this.inputFileSelectorAttr1);

        for (let [index, value] of Object.entries(targetElem.files)) {
            this.files[nextIndex + index] = {
                dataFile: value,
                isWarrantyFile: isWarranty,
            };
        }

        targetElem.value = null;

        let filesName = '';
        let i = 1;

        for (let key in this.files) {
            if (Object.prototype.hasOwnProperty.call(this.files, key)) {
                let warranty = this.files[key].isWarrantyFile ? 'warranty' : '';

                filesName += `<div class="${this.selectors.wrapElemName} ${warranty}">
                      <span class="check-icon"></span>&nbsp;
                      <span class="${this.selectors.countItem}">${i}</span>. ${this.files[key].dataFile.name}
                      <span class="close-icon" data-key="${key}" title="Удалить файл"></span>
                    </div>`;
                i++;
            }
        }

        const wrapBox = this.wrapElem.querySelector(this.wrapBoxSelector);

        if (wrapBox) {
            wrapBox.innerHTML = `<div class="${this.selectors.elemBar}"><div class="${this.selectors.elemBarItem}"></div></div>`;
            const innerElem = wrapBox.querySelector(`.${this.selectors.elemBarItem}`);

            TwoUploader.showProgressBar(filesName, wrapBox, innerElem);
        }
    };

    /**
     * Show or hide more input file
     * @param {InputEvent} e
     */
    showInputFile = (e) => {
        const elemMore = this.wrapElem.querySelector(this.moreSelector);

        if (e.target.checked === true) {
            elemMore.style.display = 'flex';
        } else {
            elemMore.style.display = 'none';
        }
    };

    /**
     * Re-number the list
     */
    recalculateList() {
        const elems = this.wrapElem.querySelectorAll(`.${this.selectors.wrapElemName}`);

        elems.forEach((element, key) => {
            const countElem = element.querySelector(`.${this.selectors.countItem}`);

            if (countElem) {
                countElem.innerHTML = `${key + 1}`;
            }
        });
    }

    /**
     * Remove file in list
     * @param {Event} e
     */
    removeFile = (e) => {
        if (!e.target.classList.contains(this.selectors.removeBtn)) {
            return;
        }

        const key = e.target.dataset.key;
        const wrapElem = e.target.closest(`.${this.selectors.wrapElemName}`);

        if (wrapElem) {
            wrapElem.remove();
            delete this.files[key];
            this.recalculateList();
        }
    };

    /**
     * Return file list
     * @returns {{}}
     */
    getFiles() {
        let newFilesList = {};

        for (let key in this.files) {
            if (Object.prototype.hasOwnProperty.call(this.files, key)) {
                newFilesList[key] = this.files[key].dataFile;
            }
        }

        return newFilesList;
    }

    /**
     * Listeners
     */
    setUpListeners() {
        const fileInput1 = this.wrapElem.querySelector(this.inputFileSelector1);
        const fileInput2 = this.wrapElem.querySelector(this.inputFileSelector2);
        const switchSelector = this.wrapElem.querySelector(this.switchSelector);

        if (!fileInput1 || !fileInput2 || !switchSelector) {
            return;
        }

        switchSelector.addEventListener('change', this.showInputFile);
        fileInput1.addEventListener('change', this.startAction);
        fileInput2.addEventListener('change', this.startAction);
        this.wrapElem.addEventListener('click', this.removeFile);
    }

    /**
     * Starter
     */
    render() {
        if (!this.wrapElem) {
            return;
        }

        this.setUpListeners();
    }
}

export default TwoUploader;
